import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import { useOutletContext } from "react-router-dom";
import ExpandableTextMobile from "../components/ExpandableText";
import { notifySuccess, notifyError } from "../components/notify";
import { BASE_MOBILE_API_URL } from "../constants";
import { BASIC_AUTH } from "../constants";
import axios from "axios";

const CustomerProfile = () => {
  const { setPageTitle } = useOutletContext();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [updateModal, setUpdateModal] = useState(false);
  const [imageError, setImageError] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const [preview, setPreview] = useState(null);
  const [qrImage, setQrImage] = useState("");
const [qrLoading, setQrLoading] = useState(false);

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  useEffect(() => {
    setPageTitle("My Profile");
  }, [setPageTitle]);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    setName(customer.name);
    setEmail(customer.email);
    setAddress(customer.address);
    setMobile(customer.whatsapp);
  }, [customer]);

  const nameRef = useRef(null);
  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  // ================= VALIDATION =================
  const validateForm = () => {
    let valid = true;

    if (!name.trim()) {
      setNameError("Name is required");
      valid = false;
    } else setNameError("");

    if (!email.trim()) {
      setEmailError("Email is required");
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError("Invalid email format");
      valid = false;
    } else setEmailError("");

    if (!address.trim()) {
      setAddressError("Address is required");
      valid = false;
    } else setAddressError("");

    if (!mobile.trim()) {
      setMobileError("Whatsapp number is required");
      valid = false;
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileError("Whatsapp number must be 10 digits");
      valid = false;
    } else setMobileError("");

    return valid;
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setImageError("");

    if (!validateForm()) return;
    setLoading(true);
    try {
      const formData = new FormData();

      formData.append("companycode", customer.companycode);
      formData.append("branchcode", customer.branchcode);
      formData.append("customercode", customer.customercode);
      formData.append("name", name);
      formData.append("email", email);
      formData.append("address", address);
      formData.append("password", customer.password);
      formData.append("whatsapp", mobile);
      formData.append("imei_no", customer.imei_no);
      if (imageFile) {
        formData.append("profileimage", base64Image);
      }

      const res = await axios.post(
        `${BASE_MOBILE_API_URL}/update_customer`,
        formData,
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );
      notifySuccess(res.data.message || "Cutomer details update successfully");
      setUpdateModal(false);
      handleCustomerSubmit();
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Customer profile update failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setImageFile(file);

  // Preview (same as before)
  setPreview(URL.createObjectURL(file));

  // Convert to Base64
  const reader = new FileReader();

  reader.readAsDataURL(file); //  gives full base64 with prefix

  reader.onload = () => {
    const base64 = reader.result;

    // store this if you want to send to API
    setBase64Image(base64);
  };

  reader.onerror = (error) => {
    console.error("Error converting image:", error);
  };
};

  const handleCustomerSubmit = async () => {
    try {
      const response = await axios.get(`${BASE_MOBILE_API_URL}/customerLogin`, {
        params: {
          mobileno: customer.mobile,
          password: customer.password,
          companycode: customer.companycode,
          branchcode: customer.branchcode,
        },
        headers: {
          Authorization: BASIC_AUTH,
        },
      });


      localStorage.setItem("loginusertype", "customer");

      localStorage.setItem("customerInfo", JSON.stringify(response.data));

      //  RELOAD PAGE AFTER LOGIN SUCCESS
      window.location.reload();
    } catch (err) {
      if (err.response) {
        const errorMessage =
          typeof err.response.data === "string"
            ? err.response.data
            : err.response.data?.message ||
              err.response.data?.error ||
              err.response.data?.RESMSG ||
              "Cutomer Login failed";

        notifyError(errorMessage);
      } else if (err.request) {
        notifyError("Server not responding. Please try again.");
      } else {
        notifyError("Something went wrong.");
      }
    }
  };

  const handleModalEntered = () => {
    setImageError("");
    setImageFile(null);
    setPreview(null);
  };

  const generateQRCode = async (customer) => {
    setQrLoading(true);
  try {
    const response = await fetch(`${BASE_MOBILE_API_URL}/generate_customer_qr_code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
         Authorization: BASIC_AUTH,
      },
      body: JSON.stringify({
        companycode: customer?.companycode,
        customercode: customer?.customercode,
        customername: customer?.name,
        mobileno: customer?.mobile,
        whatsapp_no: customer?.whatsapp,
        companyname: customer?.companyname,
        company_image: "",
        customer_image: "",
        type: customer?.customertype,
        ultra_msg_instance: customer?.company_ultra_msg_instance,
        ultra_msg_token: customer?.company_ultra_msg_token,
      }),
    });

    const data = await response.json();

    if (data?.customer_qr_code) {
      setQrImage(data.customer_qr_code); // save URL
    }
  } catch (error) {
    console.error("QR API Error:", error);
  } finally {
    setQrLoading(false);
  }
};

const hasGeneratedQR = useRef(false);
useEffect(() => {
  if (hasGeneratedQR.current) return;
  if (customer) {
    generateQRCode(customer);
    hasGeneratedQR.current = true;
  }
}, [customer]);
  return (
    <>
      <div className="row w-100 justify-content-center">
        <div className="col-lg-12">
          <div className="shadow-sm  bg-Modal-black border-none">
            <div className="card-body px-3 ">
              {/* Form */}
              <div className="container-fluid">
  <div className="row">

    {/* ✅ LEFT SIDE → FORM */}
    <div className="col-12 col-md-6 border-end-md pe-md-4">
      <form onSubmit={handleSubmit} autoComplete="off" className="px-2">

        <div className="text-center">
          <img
            src={
              customer.fullprofileimage
                ? customer.fullprofileimage
                : "/assest/user_profile.png"
            }
            onClick={() => setUpdateModal(true)}
            alt="User Logo"
            className="profile-company-logo mt-2"
            style={{ cursor: "pointer" }}
          />
        </div>

        {/* ROW 1 */}
        <div className="col-12 mt-4">
          <div className=" col-12  d-flex">
            <label className="form-label small text-white fw-semibold col-4">
              Name :
            </label>
            <input
              ref={nameRef}
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="red-error col-12 m-0 text-end mb-2">{nameError}</div>

          <div className="mb-3 col-12  d-flex">
            <label className="form-label small text-white fw-semibold col-4">
              Whatsapp :
            </label>
            <input
              type="text"
              className="form-control"
              value={mobile}
              onChange={(e) =>
                setMobile(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>
          <div className="red-error col-12 m-0 text-end mb-2">{mobileError}</div>
        </div>

        {/* ROW 2 */}
        <div className="col-12 ">
          <div className="mb-3 col-12  d-flex">
            <label className="form-label small text-white fw-semibold col-4">
              Email :
            </label>
            <input
              type="text"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
           <div className="red-error col-12 m-0 text-end mb-2">{emailError}</div>

          <div className="mb-3 col-12  d-flex">
            <label className="form-label small text-white fw-semibold col-4">
              Address :
            </label>
            <textarea
              className="form-control"
              rows="1"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
           <div className="red-error col-12 m-0 text-end mb-2">{addressError}</div>
        </div>

        {/* SUBMIT */}
        <div className="text-center mt-3 mb-2">
          <ButtonSpinner
            type="submit"
            className="col-md-5 col-lg-3 col-9 btn-theme bg-gradient-info text-dark"
            loading={loading}
          >
            <b>{loading ? "Updating..." : "Update Profile"}</b>
          </ButtonSpinner>
        </div>

      </form>
    </div>

    {/* ✅ RIGHT SIDE → QR */}
    <div className="col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mt-2">

      <div className="text-center w-100">
        {qrLoading && <p className="text-white">Generating QR...</p>}

        {qrImage && (
          <div className="qr-box">
            <img
              src={qrImage}
              alt="QR Code"
              className="img-fluid"
              style={{
                maxWidth: "250px",
                borderRadius: "12px",
                padding: "10px",
                background: "#fff",
              }}
            />
          </div>
        )}
      </div>

    </div>

  </div>
</div>
              {/* Selected Company Card */}
              {customer && (
                <div className="company-selected-card mb-4 p-2 rounded-4 mx-lg-5">
                  {/* Centered Logo */}
                  <div className="company-logo-top">
                    <img src={customer?.company_image} alt="company logo" />
                  </div>

                  {/* Company Details (same old alignment) */}
                  <div className="company-details">
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Company Name :</span>
                        <ExpandableTextMobile
                          text={`${customer?.companyname}(${customer?.companycode})`}
                          className="long-text text-white mb-1"
                        />
                      </div>

                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Company Address :</span>
                        <ExpandableTextMobile
                          text={customer?.company_address}
                          className="long-text mb-1 text-white"
                        />
                      </div>
                    </div>
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Company GSTNO :</span>
                        <span className="company-value">
                          {customer?.company_gstno}
                        </span>
                      </div>
                    </div>
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Branch Name :</span>
                        <ExpandableTextMobile
                          text={`${customer?.branchname}`}
                          className="long-remark-text text-white mb-1"
                        />
                      </div>
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Branch Address :</span>
                        <span className="company-value">
                          <ExpandableTextMobile
                            text={customer?.branch_address}
                            className="long-text mb-1 text-white"
                          />
                        </span>
                      </div>
                    </div>
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Branch Mobile :</span>
                        <span className="company-value">
                          {customer?.branch_mobileno}
                        </span>
                      </div>
                      <div className="company-row col-lg-6 col-12">
                        <span className="company-label">Branch GSTNO :</span>
                        <span className="company-value">
                          {customer?.branch_gstno}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={updateModal}
        onHide={() => {
          setUpdateModal(false);
          setPreview(null);
          setImageFile(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
        onEntered={handleModalEntered}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton className="py-1">
            <Modal.Title className="d-block">
              <div className="text-theme">Edit Profile Image</div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="d-flex gap-2">
              {/* Camera */}
              <input
                type="file"
                accept="image/*"
                capture="environment"
                id="cameraInput"
                hidden
                onChange={handleImageChange}
              />

              <button
                className="btn btn-outline-theme"
                onClick={() => document.getElementById("cameraInput").click()}
              >
                📷 Take Photo
              </button>

              {/* Gallery */}
              {/* <input
        type="file"
        accept="image/*"
        id="galleryInput"
        hidden
        onChange={handleImageChange}
      />

      <button
        className="btn btn-outline-theme"
        onClick={() =>
          document.getElementById("galleryInput").click()
        }
      >
        🖼️ Choose from Gallery
      </button> */}
            </div>
            {imageError && <p className="red-error">{imageError}</p>}

            {preview && (
              <div className="d-flex justify-content-center">
                <img
                  src={preview}
                  alt="Preview"
                  className="img-fluid mt-2 rounded "
                  style={{ maxHeight: "200px" }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setUpdateModal(false);
                setPreview(null);
                setImageFile(null);
              }}
            >
              Cancel
            </Button>

            <Button variant="success" onClick={() => setUpdateModal(false)}>
              Submit
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};
export default CustomerProfile;
